import * as React from 'react';
import * as Scroll from 'react-scroll';
import { Layout } from './Layout';
import { Prestito } from './pages/Prestito';
import { CessioneQuinto } from './pages/CessioneQuinto';
import { ContoDeposito } from './pages/ContoDeposito';
import { Choose } from './pages/Chooose';
import BodyClassName from 'react-body-classname';
import { sanObj } from '../scbsite/sanObj';
import { Helmet } from 'react-helmet'
import { MobileApp } from './pages/MobileApp';

export const DigitalCampaign1 = () => {

    React.useEffect(() => {
        Scroll.Events.scrollEvent.register('begin', function (to, element) {
            // console.log('begin', arguments);
        });

        Scroll.Events.scrollEvent.register('end', function (to, element) {
            // console.log('end', arguments);
        });

        try {
            sanObj.trackingView({
                pm: 1404471,
                divider: encodeURIComponent('|'),
                pagename: encodeURIComponent('Santander|repeat_business|c1'),
            });
        }
        catch (err) {
        }

        Scroll.scrollSpy.update();
        return () => {
            Scroll.Events.scrollEvent.remove('begin');
            Scroll.Events.scrollEvent.remove('end');
        }
    }, [])

    return <BodyClassName className="santander-react digital_campaign">
        <>
            <Helmet>
                <title>Digital Campaign</title>
            </Helmet>
            <Layout headerPageScroll="prestito-scroll">
                <Prestito onNextClickScroll="mobile-app-scroll" trackingCluster="c1" />
                <MobileApp onNextClickScroll="cessionequinto-scroll" trackingCluster="c1" />
                <CessioneQuinto onNextClickScroll="contodeposito-scroll" trackingCluster="c1" />
                <ContoDeposito onNextClickScroll="chooose-scroll" trackingCluster="c1" />
                <Choose trackingCluster="c1" />
            </Layout>
        </>
    </BodyClassName>
}